import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'

import SecondaryTitle from 'components/title_secondary/title_secondary'
import DragPicker from 'components/picker/drag/drag_picker'
import NearpodPickerBottomBar from '../../components/bottom_bar/nearpod_picker_bottom_bar'
import NearpodPickerOptions from '../../components/options/nearpod_picker_options'
import { localize } from 'helpers/translator'

import styles from './nearpod_picker_audio.scss'

class NearpodPickerAudio extends PureComponent {

	render() {
		return (
			<div styleName='wrapper'>
				<SecondaryTitle isCentered={true}>{localize('picker_audio_title')}</SecondaryTitle>
				<div styleName='file-selection'>
					<div styleName='drag-and-drop'>
						<DragPicker
							onChange={this.props.onFilesPicked}
							accept={this.props.accept}
							pickerType={this.props.pickerType}
							dropRejectedHandler={this.props.onFileError}
							multiselect={this.props.multiselect} />
					</div>
					<span styleName='source-options-or'>{localize('picker_connector_or')}</span>
					<NearpodPickerOptions
						onFilesPicked={this.props.onFilesPicked}
						onFileError={this.props.onFileError}
						multiselect={this.props.multiselect}
						accept={this.props.accept}
						googleDrivePickerOrigin={this.props.googleDrivePickerOrigin}
					/>
				</div>
				<NearpodPickerBottomBar cancelHandler={this.props.closeHandler} />
			</div>
		)
	}

}

export default CSSModules(NearpodPickerAudio, styles, {allowMultiple: true})
